<p class="title">Dashboard Vitall</p>
<!--<div class="chart-container">-->
<!--    <canvas  id="Vanzari" >{{ chart }}</canvas>-->
<!--</div>-->
